import React, { Component } from 'react';
import { Button,Input, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { baridiPay} from '../../../slices/modalSlice';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';




class BaridiModal extends Component {

    constructor(props) {
        super(props);
      }
   


    toogleClose = () =>this.props.dispatch(baridiPay())


    
    render() {
      
        return (
            <div>
              <Modal isOpen={this.props.baridiPay} toggle={this.toogleClose} contentClassName="reserveModal" centered={true}>
                   <ModalHeader className="modalHeader contactPayHeader d-flex justify-content-center align-items-center" ><center className="text-center contactPayTxt">Paiement</center></ModalHeader>
                   <ModalBody className="d-flex flex-column justify-content-center align-items-center">
                         <p className="text-center" id="especes"><img id="especesImg" src="/imgs/resrervationIcons/baridi.png" alt="Baridimob"/>CCP / Baridimob</p>
                      <div className="payChoice">
                        <label className="virementMan d-flex align-items-center" check>
                          <Input className="virementRadio"  type="radio" name="radio1" checked />{' '}
                          <div className="virementBox">
                            <div className="virementHead selectedHead">Virement CCP</div>
                            <div className="virementContent">
                              <p className="virementTxt grayTxt">Veuillez scanner, prendre une photo CLAIRE du talon de votre virement vers le compte CCP</p>
                              <div className="addressUpload d-flex justify-content-between">
                                <div className="virementAddress">
                                <b>
                                  <p className=" grayTxt">SARL Ghurfaty<br/>
                                  CCP 001245786 Clé 88<br/>
                                  Skikda</p>
                                </b>
                                </div>
                                <div class='file file--upload'>
                                   <label for='input-file'>
                                      <img width="18px" height="18px" src="/imgs/resrervationIcons/upload.png" alt="resrervation" />
                                   </label>
                                   <input id='input-file' type='file' />
                                </div>
  

                              </div>
                            </div>
                          </div>
                        </label>
                        <label className="virementApp d-flex align-items-center"  check>
                          <Input className="virementRadio" type="radio" name="radio1" />{' '}
                          <div className="virementBox">
                            <div className="virementHead unselectedHead">Via l'Application BaridiMob</div>
                            <div className="virementContent">
                              <p className="virementTxt grayTxt">Veuillez envoyer le reçu du virement à la boite e-mail : <b>virement@ghurfaty.net</b></p>
                              <b className="grayTxt">RIP : 0079999900124578677</b>
                              <div className="refTransaction d-flex  align-items-center mt-2">
                                <p className="refText">Réf. Transaction</p>
                                <input className="refInput" type="text" />
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                  
                      <Button className="contactPayBtns precedBtn d-flex align-items-center justify-content-between mt-3">
                        <span></span>
                        <span className="text-center">Suivant</span>
                       
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 14.839 29.677">
                             <path id="Tracé_521" data-name="Tracé 521" d="M7671.4-1190l7.652,10.652L7671.4-1168.7" transform="translate(-7667.213 1194.187)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                        </svg>
                      </Button>
                      <Button onClick={this.toogleClose} className="contactPayBtns annulerBtn d-flex justify-content-center"><span className="mr-3">Annuler</span></Button>
                   </ModalBody>
              </Modal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
      
      baridiPay : state.modal.baridi
      
    }
}
export default withRouter(connect(mapStateToProps)(BaridiModal));
